import { RANGE_TIME } from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const DEFAULT_FORM_VALUE = {
  [RANGE_TIME]: {
    type: 'date',
    value: ['', ''],
  },
};


export const STATIC_FILTER_CONFIGS = {
  RANGE_TIME: {
    type: RANGE_TIME,
    key: RANGE_TIME,
    calendarType: 'date',
    showSelectType: true,
    showShortcut: false,
    default: [],
  },
};
